import data from '../root/root.json';
import { BreadcrumbTitles } from '../utils/hair.utils';
const handleBreadCrumbOnLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const statedata = await handlers.getBreadCrumbState();
    const dataArray = statedata.length > 0 ? statedata : await handleBreadcrumbValues(data);

    if (statedata.length < 1) {
      await handlers.updateBreadCrumbState(dataArray);
    }
    return dataArray;
  } else {
    return [];
  }
};

const handleBreadcrumbValues = async (data: any[]) => {
  let newBreadCrumbs: any[] = [];

  data.forEach(item => {
    if (BreadcrumbTitles[item.value]) {
      newBreadCrumbs.push({
        title: BreadcrumbTitles[item.value],
        name: item.value,
        enabled: false,
      });
    }
  });

  return newBreadCrumbs;
};
export { handleBreadCrumbOnLoad };
